import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { ReactMarkdownProps } from 'react-markdown/lib/ast-to-react';
import rehypeRaw from 'rehype-raw';
import DOMPurify from 'dompurify';
import { List, ListType } from '../list';

interface MarkdownProps
    extends Omit<ReactMarkdownProps, 'children' | 'node' | 'key'> {
    children: string | undefined;
    noParagraph?: true;
    listType?: ListType;
}

export const Markdown = (props: MarkdownProps) => {
    if (!props.children) {
        return null;
    }
    const sanitizedChildren = DOMPurify.sanitize(props.children);
    return (
        <ReactMarkdown
            {...props}
            rehypePlugins={[rehypeRaw]}
            components={{
                img: ({ src, alt }) => (
                    <img
                        src={src}
                        alt={alt}
                        style={{ maxWidth: '100%', height: 'auto' }}
                    />
                ),
                span: ({ children, style }) => {
                    const mystyle: { color?: string; fontSize?: string } =
                        (style as {
                            color?: string;
                            fontSize?: string;
                        }) || {};
                    const color = mystyle.color;
                    const fontSize = mystyle.fontSize;
                    return (
                        <span
                            className="simplified"
                            style={{
                                color,
                                fontSize
                            }}
                        >
                            {children}
                        </span>
                    );
                },
                p: ({ children }) =>
                    props.noParagraph ? <>{children}</> : <p>{children}</p>,
                ul: ({ children }) =>
                    props.listType ? (
                        <List type={props.listType}>{children}</List>
                    ) : (
                        <ul>{children}</ul>
                    )
            }}
        >
            {sanitizedChildren}
        </ReactMarkdown>
    );
};
